export default function BadgeBoardComponent({ icon, heading, value }) {
  return (
    <div className={'badgeItem'}>
      {icon}
      <div className="badgeTitle">{heading}</div>
      <div className="badgeValue">{value}</div>
    </div>
  )
}
